import React, { useState } from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import Filters from './Filters'
import * as AnalisiLead from "./analisiLead/AnalisiLead";
import * as TimeLead from "./analisiLead/TimeLead";
import * as RankingLead from "./analisiLead/RankingLead";
import ComponentSlider from "src/mtska-frontend-app-component/components/Slider/ComponentSlider";
import { Button } from "src/mtska-frontend-app-component";
import JSONPretty from 'react-json-pretty'
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";

const Container = ({ dataProviderName, filters:defaultFilters }) => {
    const { t } = useTranslation();
    const [reportVisible, setReportVisible] = useState(false);
    const { filterModel } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const showFilters = true;
    const showKPI = true;

    const report = [
        {
            title: t('Lead'),
            icon: 'faChartPyramid',
            pages: [
                {
                    title: t('Andamento'),
                    icon: 'faCalendar',
                    component: <TimeLead.default dataProviderName={dataProviderName} filters={filterModel} key={1} />
                },
                {
                    title: t('Classifiche'),
                    icon: 'faRankingStar',
                    component: <RankingLead.default dataProviderName={dataProviderName} filters={filterModel} key={1} />
                },
                {
                    title: t('Analisi'),
                    icon: 'faChartPie',
                    component: <AnalisiLead.default dataProviderName={dataProviderName} filters={filterModel} key={1} />
                }
            ]
        }
    ];

    return (
        <Box>
            {/* filtri in Container
            <JSONPretty data={filterModel} className="json-wrapper" /> */}
            {(showKPI || showFilters) &&
                <Box className="dashboard-section-title" sx={{ marginTop: '30px', marginBottom: '10px' }}>
                    <h2>{t('Lead status')}</h2>
                </Box>
            }

            {showFilters &&
                <Filters dataProviderName={dataProviderName} filters={filterModel} />
            }

            <Box className="dashboard-report-visibility-wrapper">
                <Button className="dashboard-report-visibility-toggler" onClick={() => setReportVisible(!reportVisible)} variant={'outlined'}>{reportVisible ? t('Hide report') : t('Show report')}</Button>
            </Box>

            {
                reportVisible && <ComponentSlider report={report} />
            }
        </Box>
    )
}

export default Container;